import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPilone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPilone"><Path d="M7.18359 9L9.18359 2H14.815L16.815 9H7.18359Z" fill="currentColor"/><Path d="M6.75558 10.5L5.89844 13.5H18.1013L17.2442 10.5H6.75558Z" fill="currentColor"/><Path d="M18.53 15H5.46999L4.18427 19.5H2V21H22V19.5H19.8157L18.53 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPilone;
